/**
 * El símbolo de la marca (PDF de Ana, 2026-09-01): la bandada compactada.
 * Reglas del manual: cuatro capas por defecto, tres a ≤32 px, dos a ≤16 px;
 * siempre vértice arriba, nunca rotado. Color = currentColor (grafito en la
 * marca corporativa; el azul vive en la interfaz, no en el símbolo).
 * NOTA: trazado provisional reconstruido del PDF — sustituir por el SVG
 * maestro de Ana cuando llegue.
 */
const LAYERS = [
  "M2 8.5 L12 2.5 L22 8.5",
  "M4 13 L12 8 L20 13",
  "M6.5 17.5 L12 13.5 L17.5 17.5",
  "M9 21.5 L12 19.3 L15 21.5",
];
export function Symbol({ size = 24, className, title }: { size?: number | undefined; className?: string | undefined; title?: string | undefined }) {
  const layers = size <= 16 ? 2 : size <= 32 ? 3 : 4;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="butt" strokeLinejoin="miter" role={title ? "img" : undefined} aria-hidden={title ? undefined : true} className={className}>
      {title && <title>{title}</title>}
      {LAYERS.slice(0, layers).map((d) => <path key={d} d={d} />)}
    </svg>
  );
}
